import React from "react";
import { useSelector } from "react-redux";

import { get } from "lodash";


const emptyArr = [];

export const resolutionsSelector = type => state => get(state, `tenant.resolutions.${type}`, emptyArr);

export const useResolutions = type => {
	return useSelector(resolutionsSelector(type));
};
